import {useSetContentApprovalMutation} from "@/api/campaignApi";
import Button from "@/components/Common/Button";
import Modal from "@/components/Common/Modal";
import {useComposedCampaignState, useMiscActions} from "@/store/campaignForm";
import {revertFromAiContentApprovalModalAtom} from "@/store/jotaiAtoms";
import {useAtom} from "jotai";
import type {FC} from "react";
import {useTranslation} from "react-i18next";

const RevertFromAiContentApprovalModal: FC = () => {
  const {t} = useTranslation(["content_approval", "common"]);
  const [targetMode, setTargetMode] = useAtom(revertFromAiContentApprovalModalAtom);
  const campaignId = useComposedCampaignState(state => state.misc.id);
  const actions = useMiscActions();
  const {setContentApproval, isPending} = useSetContentApprovalMutation(Number(campaignId));

  return (
    <Modal
      backgroundClassName="max-w-md"
      customBottomRow={
        <div className="border-neutral-white-dark flex justify-end gap-3 border-t px-5 py-4">
          <Button buttonStyle="White" className="px-5 py-2.5" onClick={() => setTargetMode(null)}>
            {t("common:cancel")}
          </Button>
          <Button
            buttonStyle="Blue"
            className="px-5 py-2.5"
            isLoading={isPending}
            onClick={() =>
              setContentApproval(
                {mode: targetMode ?? "manual"},
                {
                  onSuccess: () => {
                    actions.setMiscValue("contentApprovalMode", targetMode ?? "manual");
                    actions.setMiscValue("storyApprovalMode", "off");
                    setTargetMode(null);
                  },
                },
              )
            }>
            {t("revert_from_ai_confirm")}
          </Button>
        </div>
      }
      isLoading={isPending}
      modalTitle={t("revert_from_ai_title")}
      onClose={() => setTargetMode(null)}>
      <p className="text-neutral-grey-dark text-sm leading-relaxed">{t("revert_from_ai_description")}</p>
    </Modal>
  );
};

export default RevertFromAiContentApprovalModal;
